export const BASE_HREF = "/portfolio/site-portal";
export const REACT_APP_EMAILJS_SERVICE_ID = "service_t6n0wcf";
export const REACT_APP_EMAILJS_TEMPLATE_ID = "template_0ggchvv";
export const REACT_APP_EMAILJS_PUBLIC_KEY = "YjxAeSjLHWZcnRbSn";